import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../seo.css';
import '../Service/scervice.scss';
import img from './../../../assets/Img';
import ServicesSlider from './../ServicesSlider';
import ServicesSection from './ServicesSection';
import SocialMediaSection3 from './SocialMediaSection3';
import Component from '../../../constants/Component';
import WhyChooseRightClick from '../branding/WhyChooseRightClick';
const translations = {
    en: require('../../../Translate/en.json').ContentMarketing,
    ar: require('../../../Translate/ar.json').ContentMarketing,
};
const ContentMarketing = () => {
    const { i18n } = useTranslation();
    const isLang = i18n.language;
    const t = translations[isLang || 'en'];

    const data = {
        title: t.title,
        dec: t.dec,
        img: img.ContentMarketing,
        title2: t.title2,
        dec2: t.dec2,
    };
    const contentKeys = ['SalesCopywriting', 'BrandStorytelling', 'AdCopy'];
 useEffect(() => { 
    window.scroll(0, 0)  
  }, [])

    return (
        <div>
            <div className="overflow-hidden">
                <ServicesSlider t={t} data={data} />

                <div className="copywriting-container">
                    <div className="container">
                        <div className="copywriting-header">
                            <h2>{t.CopywritingServicesh}</h2>
                            <p>
                                {t.CopywritingServicesp} <span>{t.CopywritingServicesSpan}</span>
                            </p>
                        </div>
                        <div className="copywriting-cards">
                            {contentKeys.map((key, index) => (
                                <div key={index} className="copywriting-card">
                                    <h3>{t[key].title}</h3>
                                    <p>{t[key].description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
            <ServicesSection />
            <SocialMediaSection3 />
            <WhyChooseRightClick />

            <Component.ContactUSHome />
        </div>
    )
}

export default ContentMarketing
